import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../flux/configureStore';
import constants from '../flux/constants';
import PriceMyRentalComponent from './component';
import isEqual from 'lodash/isEqual';
import { areComparablesEqual } from '../utils/comparablesUtils';

import type { PropsWithState } from '.';

const PriceMyRentalAppAdapter: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<PropsWithState>>
> = (props) => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state);
  const { address, comparables, filter, app, ui, setFilter, heading } = props;

  useEffect(() => {
    dispatch({
      type: constants.SET_APP_VALUES,
      payload: app,
    });
  }, [app, dispatch]);

  useEffect(() => {
    dispatch({
      type: constants.SET_HOVER_ID,
      payload: ui.hoverId,
    });
    dispatch({
      type: constants.SET_ACTIVE_ID,
      payload: ui.activeId,
    });
  }, [ui, dispatch]);

  useEffect(() => {
    dispatch({
      type: constants.INIT_SET_FILTER,
      payload: setFilter,
    });
  }, [setFilter, dispatch]);

  // Do not update these in useEffect so they are available on SSR
  if (!isEqual(address, state.address)) {
    dispatch({
      type: constants.SET_ADDRESS,
      payload: address,
    });
  }

  if (!isEqual(filter, state.filter)) {
    dispatch({
      type: constants.UPDATE_FILTER,
      payload: filter,
    });
  }

  if (!areComparablesEqual(comparables, state.comparables)) {
    dispatch({
      type: constants.SET_COMPARABLES,
      payload: comparables,
    });
  }

  return <PriceMyRentalComponent heading={heading} />;
};

export default PriceMyRentalAppAdapter;
